import React, { useEffect } from "react";

const TawkChat = () => {
  useEffect(() => {
    // Initialize Tawk.to script
    const Tawk_API = window.Tawk_API || {};
    const Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/676ea34449e2fd8dfefefbd0/1ig42rhik";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      // Cleanup script to prevent duplicate widgets
      document.body.removeChild(script);
    };
  }, []);

  return null; // No visible output needed
};

export default TawkChat;
